export const INSTITUTION_SESSION_TESTS_UI = [
  {
    label: 'Prueba rendida', key: 'testName', typeField: 'text', valueType: 'string',
  },
  {
    label: 'Buenas', key: 'correctAnswers', typeField: 'text', valueType: 'string',
  },
  {
    label: 'Puntaje', key: 'score', typeField: 'text', valueType: 'string',
  },
  {
    label: 'Estado', key: 'status', typeField: 'text', valueType: 'string',
  },
  {
    label: '', key: 'action', valueType: 'other',
  },
];

export interface InstitutionSessionUserTestResume {
  institutionSessionUserTestId: number,
  testName: string,
  correctAnswers: number,
  score: number | string,
  status: string,
  active: boolean,
}

export interface InstitutionSessionUserTestRow extends InstitutionSessionUserTestResume {
  canAnswer: boolean,
  action?: JSX.Element,
}

export const STATUS_LABELS: Record<string, string> = {
  'En proceso': 'Iniciar prueba',
  Completado: 'Prueba rendida',
};
